import { useClickable } from '@chakra-ui/clickable';
import { Flex, Heading, Text, useDisclosure } from '@chakra-ui/react';
import moment from 'moment';
import Todo from '../Todo';
import TodoIcon from '../TodoIcon';
import { TodoItemProps } from '../types';

function TodoItem({ todo, ...props }: TodoItemProps) {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const clickableProps = useClickable({ onClick: onOpen });

  return (
    <>
      <Flex {...props} {...clickableProps} role="group" _hover={{ cursor: 'pointer' }}>
        <TodoIcon
          done={todo.done}
          target={todo.target}
          kind={todo.kind}
          _groupHover={{ bg: 'purple.500' }}
        />
        <Flex direction="column" textAlign="left" ml={2} justify="center">
          <Heading as="h6" size="xs" noOfLines={1}>
            {todo.target.name}
          </Heading>
          <Text>Due on {moment(todo.deadline).format('ll')}</Text>
        </Flex>
      </Flex>
      <Todo isOpen={isOpen} onClose={onClose} todo={todo} />
    </>
  );
}

export default TodoItem;
